import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
export function CoverSlide() {
  return <SlideLayout centered data-id="element-135">
      {/* Abstract top shapes */}
      <div className="absolute top-0 right-0 w-[300px] sm:w-[450px] md:w-[600px] h-[300px] sm:h-[450px] md:h-[600px] bg-gold-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 pointer-events-none" data-id="element-136" />
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] bg-[size:40px_40px] sm:bg-[size:64px_64px] pointer-events-none" data-id="element-137" />

      <div className="relative z-10 flex flex-col items-center justify-center px-2 pt-8 sm:pt-12 md:pt-16" data-id="element-138">
        <div className="inline-flex items-center px-3 sm:px-4 py-1 sm:py-1.5 rounded-full bg-gold-500/10 border border-gold-500/20 text-gold-600 text-xs sm:text-sm font-semibold tracking-wide mb-4 sm:mb-8" data-id="element-139">
          SEO Audit & Growth Proposal
        </div>

        <h1 className="text-3xl sm:text-5xl md:text-7xl font-extrabold text-slate-900 mb-3 sm:mb-6 tracking-tight" data-id="element-140">
          Cutting Edge Lending
        </h1>

        <p className="text-base sm:text-xl md:text-2xl text-slate-600 font-light mb-6 sm:mb-12 max-w-2xl" data-id="element-141">
          Strategic SEO & Digital Growth Plan
        </p>

        <div className="w-14 sm:w-20 h-1 bg-gradient-to-r from-gold-500 to-gold-600 rounded-full mb-6 sm:mb-12" data-id="element-142" />

        <div className="flex flex-col items-center gap-2 sm:gap-4" data-id="element-143">
          <span className="text-xs sm:text-sm text-gold-600 uppercase tracking-[0.2em] font-bold" data-id="element-144">
            Prepared by
          </span>
          <img src="https://cdn.magicpatterns.com/uploads/5yQmgLdmxXwt1kmPQacBfs/Logo_Digilite_New-01.png" alt="Digilite" className="h-12 sm:h-16 md:h-20 opacity-90" data-id="element-145" />
          <span className="text-xs sm:text-sm text-slate-500" data-id="element-146">March 2026</span>
        </div>
      </div>

      {/* Abstract bottom shapes */}
      <div className="absolute bottom-16 sm:bottom-24 left-1/2 -translate-x-1/2 flex items-end gap-3 sm:gap-4 opacity-20 pointer-events-none" data-id="element-147">
        <div className="w-10 sm:w-16 h-16 sm:h-24 border-2 border-gold-500 rounded-t-full" data-id="element-148" />
        <div className="w-16 sm:w-24 h-20 sm:h-32 border-2 border-gold-500 rounded-t-full" data-id="element-149" />
        <div className="w-10 sm:w-16 h-12 sm:h-20 border-2 border-gold-500 rounded-t-full" data-id="element-150" />
      </div>
    </SlideLayout>;
}